/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ format: NonNullable<unknown>, path: NonNullable<unknown> }} Drastic_Tech_File_Created_LogInputs */

const en_drastic_tech_file_created_log = /** @type {(inputs: Drastic_Tech_File_Created_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.format} file created at ${i?.path}`)
};

const fr_drastic_tech_file_created_log = /** @type {(inputs: Drastic_Tech_File_Created_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fichier ${i?.format} cree a ${i?.path}`)
};

const de_drastic_tech_file_created_log = /** @type {(inputs: Drastic_Tech_File_Created_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.format}-Datei erstellt in ${i?.path}`)
};

const it_drastic_tech_file_created_log = /** @type {(inputs: Drastic_Tech_File_Created_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`File ${i?.format} creato in ${i?.path}`)
};

const ru_drastic_tech_file_created_log = /** @type {(inputs: Drastic_Tech_File_Created_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Файл ${i?.format} создан в ${i?.path}`)
};

const es_drastic_tech_file_created_log = /** @type {(inputs: Drastic_Tech_File_Created_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Archivo ${i?.format} creado a las ${i?.path}`)
};

const zh_cn2_drastic_tech_file_created_log = /** @type {(inputs: Drastic_Tech_File_Created_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.format} 文件创建于 ${i?.path}`)
};

const ja_drastic_tech_file_created_log = /** @type {(inputs: Drastic_Tech_File_Created_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.format} ファイルが ${i?.path} に作成されました`)
};

const hi_drastic_tech_file_created_log = /** @type {(inputs: Drastic_Tech_File_Created_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.format} फ़ाइल ${i?.path} पर बनाई गई`)
};

const pt_pt2_drastic_tech_file_created_log = /** @type {(inputs: Drastic_Tech_File_Created_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Arquivo ${i?.format} criado em ${i?.path}`)
};

/**
* | output |
* | --- |
* | "{format} file created at {path}" |
*
* @param {Drastic_Tech_File_Created_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_file_created_log = /** @type {((inputs: Drastic_Tech_File_Created_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_File_Created_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_file_created_log(inputs)
	if (locale === "de") return de_drastic_tech_file_created_log(inputs)
	if (locale === "it") return it_drastic_tech_file_created_log(inputs)
	if (locale === "ru") return ru_drastic_tech_file_created_log(inputs)
	if (locale === "es") return es_drastic_tech_file_created_log(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_file_created_log(inputs)
	if (locale === "ja") return ja_drastic_tech_file_created_log(inputs)
	if (locale === "hi") return hi_drastic_tech_file_created_log(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_file_created_log(inputs)
	return en_drastic_tech_file_created_log(inputs)
});